"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggedNotificationController = void 0;
const workers_1 = require("../services/workers");
const storage_1 = require("../services/storage");
const notifications_1 = require("../services/notifications");
const common_1 = require("../utils/common");
const constants_1 = require("../constants");
const DEFAULT_COMMERTIAL_EXPIRATION_MS = 5 * 60 * 1000;
function isObject(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
function getStringValue(value) {
    return typeof value === "string" ? value : "";
}
function getNormalizedPullNotification(notification = {}) {
    var _a, _b, _c, _d;
    if (!isObject(notification)) {
        return null;
    }
    const titleText = getStringValue((_a = notification === null || notification === void 0 ? void 0 : notification.title) === null || _a === void 0 ? void 0 : _a.text) || getStringValue(notification === null || notification === void 0 ? void 0 : notification.title);
    const descriptionText = getStringValue((_b = notification === null || notification === void 0 ? void 0 : notification.description) === null || _b === void 0 ? void 0 : _b.text) ||
        getStringValue(notification === null || notification === void 0 ? void 0 : notification.description);
    const href = getStringValue((_c = notification === null || notification === void 0 ? void 0 : notification.button) === null || _c === void 0 ? void 0 : _c.href) ||
        getStringValue(notification === null || notification === void 0 ? void 0 : notification.href) ||
        "";
    const normalizedNotification = {
        layout: "servicing",
        label: { label: "" },
        title: { text: titleText },
        description: { text: descriptionText },
        button: {
            label: getStringValue((_d = notification === null || notification === void 0 ? void 0 : notification.button) === null || _d === void 0 ? void 0 : _d.label) ||
                getStringValue(notification === null || notification === void 0 ? void 0 : notification.label) ||
                "Ver detalle",
            href,
        },
    };
    const notificationHash = getStringValue(notification === null || notification === void 0 ? void 0 : notification.notificationHash);
    if (notificationHash) {
        normalizedNotification.notificationHash = notificationHash;
    }
    if (typeof (notification === null || notification === void 0 ? void 0 : notification.read) === "boolean") {
        normalizedNotification.read = notification.read;
    }
    else if (typeof (notification === null || notification === void 0 ? void 0 : notification.status) === "string") {
        normalizedNotification.read = notification.status !== "NOT_READ";
    }
    const date = getStringValue(notification === null || notification === void 0 ? void 0 : notification.date);
    if (date) {
        normalizedNotification.date = date;
    }
    const notificationUserId = getStringValue(notification === null || notification === void 0 ? void 0 : notification.notificationUserId);
    if (notificationUserId) {
        normalizedNotification.notificationUserId = notificationUserId;
    }
    return normalizedNotification;
}
function getNotificationDedupKey(notification = {}) {
    var _a, _b, _c;
    return (getStringValue(notification === null || notification === void 0 ? void 0 : notification.notificationHash) ||
        `${getStringValue((_a = notification === null || notification === void 0 ? void 0 : notification.title) === null || _a === void 0 ? void 0 : _a.text)}|${getStringValue((_b = notification === null || notification === void 0 ? void 0 : notification.description) === null || _b === void 0 ? void 0 : _b.text)}|${getStringValue((_c = notification === null || notification === void 0 ? void 0 : notification.button) === null || _c === void 0 ? void 0 : _c.href)}|${getStringValue(notification === null || notification === void 0 ? void 0 : notification.date)}`);
}
function mergeUniqueNotifications(baseNotifications = [], incomingNotifications = []) {
    const merged = [];
    const usedKeys = new Set();
    const pushUnique = (notification) => {
        const key = getNotificationDedupKey(notification);
        if (!key || usedKeys.has(key)) {
            return;
        }
        usedKeys.add(key);
        merged.push(notification);
    };
    baseNotifications.forEach(pushUnique);
    incomingNotifications.forEach(pushUnique);
    return merged;
}
function getNotificationListFromNotificationsByType(notificationsByType = {}) {
    const notificationList = [];
    Object.values(notificationsByType).forEach((notificationByType) => {
        const notifications = Array.isArray(notificationByType === null || notificationByType === void 0 ? void 0 : notificationByType.notifications)
            ? notificationByType.notifications
            : [];
        if (notifications.length > 0) {
            notificationList.push(...notifications);
        }
    });
    notificationList.sort((a, b) => { var _a, _b; return ((_a = a === null || a === void 0 ? void 0 : a.order) !== null && _a !== void 0 ? _a : Infinity) - ((_b = b === null || b === void 0 ? void 0 : b.order) !== null && _b !== void 0 ? _b : Infinity); });
    return mergeUniqueNotifications([], notificationList);
}
function buildCommertialNotificationFromList({ notificationList = [], currentCommertial = {}, }) {
    const normalizedPullNotifications = notificationList
        .map((notification) => getNormalizedPullNotification(notification))
        .filter(Boolean);
    if (normalizedPullNotifications.length === 0) {
        return null;
    }
    const currentNotifications = Array.isArray(currentCommertial === null || currentCommertial === void 0 ? void 0 : currentCommertial.notifications)
        ? currentCommertial.notifications
        : [];
    const mergedNotifications = mergeUniqueNotifications(currentNotifications, normalizedPullNotifications);
    const hashList = mergedNotifications
        .map((notification) => getStringValue(notification === null || notification === void 0 ? void 0 : notification.notificationHash))
        .filter(Boolean);
    return Object.assign(Object.assign({}, (isObject(currentCommertial) ? currentCommertial : {})), { expiration: (currentCommertial === null || currentCommertial === void 0 ? void 0 : currentCommertial.expiration) ||
            Date.now() + DEFAULT_COMMERTIAL_EXPIRATION_MS, notifications: mergedNotifications, hashList });
}
function getSafeNotificationsByType(response = {}) {
    return isObject(response === null || response === void 0 ? void 0 : response.notifications) ? response.notifications : {};
}
function hasNotificationData(notification) {
    return Array.isArray(notification === null || notification === void 0 ? void 0 : notification.notifications);
}
function loggedNotificationController({ worker, context, userPq, userRecom, customer, addNotifications, userPo, skipCache, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const userId = context === null || context === void 0 ? void 0 : context.userIdPartyHash;
        const { cachedUnreadNotifications, cachedNotifications, cachedNotificationList, } = yield (0, storage_1.getCachedNotifications)({ userId });
        const safeCachedNotifications = isObject(cachedNotifications)
            ? cachedNotifications
            : {};
        const safeCachedNotificationList = Array.isArray(cachedNotificationList) && cachedNotificationList.length > 0
            ? mergeUniqueNotifications([], cachedNotificationList)
            : getNotificationListFromNotificationsByType(safeCachedNotifications);
        const safeCachedUnreadNotifications = Array.isArray(cachedUnreadNotifications)
            ? cachedUnreadNotifications
            : [];
        let { outdatedNotis } = (0, notifications_1.clusterNotificationTypesByExpiration)(safeCachedNotifications);
        const finalNotifications = Object.assign({}, safeCachedNotifications);
        let unreadNotifications = safeCachedUnreadNotifications;
        if (safeCachedNotificationList.length > 0) {
            addNotifications({
                notifications: safeCachedNotifications,
                notificationList: safeCachedNotificationList,
                unreadNotifications,
            });
        }
        if (outdatedNotis.length === 0) {
            addNotifications({
                notifications: finalNotifications,
                notificationList: safeCachedNotificationList,
                unreadNotifications,
                finish: true,
            });
            return { worker };
        }
        if (!worker) {
            worker = yield (0, workers_1.spawnWorkerInstance)(constants_1.WORKER_TYPES.NOTIFICATION);
        }
        if (!worker) {
            addNotifications({
                notifications: finalNotifications,
                notificationList: safeCachedNotificationList,
                unreadNotifications,
                finish: true,
            });
            return { worker };
        }
        let workerResponse = null;
        try {
            workerResponse = yield (0, workers_1.getNotificationsFromWorker)({
                worker,
                params: {
                    context,
                    userPq,
                    userRecom,
                    customer,
                    userPo,
                    skipCache,
                },
                notificationTypes: outdatedNotis,
            });
        }
        catch (error) {
            worker = yield (0, workers_1.cancelWorkerInstance)(worker, "logged_get_notifications_failed");
            console.log("[notifications-worker] getNotifications failed", {
                outdatedNotis,
                error: (error === null || error === void 0 ? void 0 : error.message) || `${error}`,
            });
        }
        let workerNotificationsByType = getSafeNotificationsByType(workerResponse);
        const workerNotificationList = Array.isArray(workerResponse === null || workerResponse === void 0 ? void 0 : workerResponse.notificationList)
            ? workerResponse.notificationList
            : [];
        if (workerNotificationList.length > 0) {
            const workerCommertial = buildCommertialNotificationFromList({
                notificationList: workerNotificationList,
                currentCommertial: workerNotificationsByType[constants_1.NOTIFICATION_TYPES.COMMERTIAL] ||
                    safeCachedNotifications[constants_1.NOTIFICATION_TYPES.COMMERTIAL] ||
                    {},
            });
            if (workerCommertial) {
                workerNotificationsByType = Object.assign(Object.assign({}, workerNotificationsByType), { [constants_1.NOTIFICATION_TYPES.COMMERTIAL]: workerCommertial });
            }
        }
        const typesToUpdate = Array.from(new Set([...outdatedNotis]));
        if (workerNotificationsByType[constants_1.NOTIFICATION_TYPES.COMMERTIAL] &&
            !typesToUpdate.includes(constants_1.NOTIFICATION_TYPES.COMMERTIAL)) {
            typesToUpdate.push(constants_1.NOTIFICATION_TYPES.COMMERTIAL);
        }
        typesToUpdate.forEach((type) => {
            const cachedByType = safeCachedNotifications === null || safeCachedNotifications === void 0 ? void 0 : safeCachedNotifications[type];
            const workerByType = workerNotificationsByType === null || workerNotificationsByType === void 0 ? void 0 : workerNotificationsByType[type];
            const nextByType = type === constants_1.NOTIFICATION_TYPES.COMMERTIAL &&
                workerByType &&
                !hasNotificationData(workerByType)
                ? cachedByType
                : workerByType || cachedByType;
            if (!nextByType) {
                return;
            }
            const { notification, unreadHashList } = (0, notifications_1.normalizeReadNotification)(cachedByType, nextByType);
            finalNotifications[type] = notification;
            unreadNotifications = (0, common_1.mergeArryUnique)(unreadNotifications, unreadHashList);
        });
        const finalNotificationList = getNotificationListFromNotificationsByType(finalNotifications);
        yield (0, storage_1.setCachedNotifications)({
            userId,
            notifications: finalNotifications,
            notificationList: finalNotificationList,
            unreadNotifications,
        });
        addNotifications({
            notifications: finalNotifications,
            notificationList: finalNotificationList,
            unreadNotifications,
            finish: true,
        });
        return { worker };
    });
}
exports.loggedNotificationController = loggedNotificationController;
exports.default = loggedNotificationController;
//# sourceMappingURL=logged.js.map